// Activity log — chronological feed of every admin action.

import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listAudit } from '../lib/api';

export function AuditView() {
  const [actionFilter, setActionFilter] = useState('');
  const auditQuery = useQuery({
    queryKey: ['audit', actionFilter],
    queryFn: () => listAudit({ limit: 100, action: actionFilter || undefined }),
  });

  return (
    <div className="view">
      <header className="view-head">
        <div>
          <h1>Activity</h1>
          <p className="sub">Every admin action, oldest at the bottom.</p>
        </div>
        <div className="view-head__actions">
          <select value={actionFilter} onChange={(e) => setActionFilter(e.target.value)}>
            <option value="">All actions</option>
            <option value="attach">attach</option>
            <option value="bulk_attach">bulk_attach</option>
            <option value="template_create">template_create</option>
            <option value="template_duplicate">template_duplicate</option>
            <option value="template_archive">template_archive</option>
            <option value="impersonate_session_started">impersonate_session_started</option>
            <option value="admin_add">admin_add</option>
            <option value="admin_patch">admin_patch</option>
          </select>
        </div>
      </header>

      {auditQuery.isLoading ? (
        <div className="state">Loading…</div>
      ) : auditQuery.isError ? (
        <div className="state error">{(auditQuery.error as Error).message}</div>
      ) : (auditQuery.data?.entries.length ?? 0) === 0 ? (
        <div className="state">Nothing logged yet.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Admin</th>
              <th>Action</th>
              <th>Target</th>
              <th>Shop</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {auditQuery.data!.entries.map((e) => (
              <tr key={e.id}>
                <td>{new Date(e.created_at).toLocaleString()}</td>
                <td>{e.admin_email}</td>
                <td>
                  <span className="tag">{e.action}</span>
                </td>
                <td>
                  {e.target_type ? (
                    <code style={{ fontSize: 11 }}>
                      {e.target_type}/{e.target_id?.slice(0, 8)}
                    </code>
                  ) : (
                    '—'
                  )}
                </td>
                <td>{e.shop_domain ?? '—'}</td>
                <td>
                  <code style={{ fontSize: 11 }}>
                    {e.payload ? JSON.stringify(e.payload).slice(0, 80) : '—'}
                  </code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
